let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("xDkFq")).then(() => parcelRequire('7OZkg'));